module.exports = __webpack_public_path__ + "static/media/John.fbd8465a.jpg";